const findService = (array: any[], key: any, reference: string): any => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][key] === reference) {
      return array[i];
    }
  }
};

export default findService;
